import { useTheme } from '../../theme/ThemeContext';
export const useTextareaStyles = ({
  isDisabled
}) => {
  const theme = useTheme();
  const textareaStyle = {
    display: 'block',
    width: '100%',
    padding: '8px',
    fontSize: theme.fontSizes.lg,
    border: `1px solid ${theme.colors.border}`,
    borderRadius: theme.radius.sm,
    boxSizing: 'border-box',
    color: theme.colors.text,
    opacity: isDisabled ? 0.6 : 1,
    minHeight: '80px',
    resize: 'vertical',
    fontFamily: 'inherit'
  };
  return {
    textareaStyle
  };
};